import { useQuery } from '@apollo/client';
import { useMediaQuery } from '../../hooks/mediaQuery';
import GuidesDesk from './guidesDeskstop';
import GuidesMobile from './guidesMobile';
import { GUIDES, GUIDES_INTERFACE } from '../../api/guides';

interface IProps {
  guidesData: any;
}
const OurGuides = () => {
  const mediaQuery = useMediaQuery(768);
  const { data: guidesData, loading } = useQuery<GUIDES_INTERFACE>(GUIDES);
  return (
    <section id="our_guides" className="lg:mt-10">
      <div
        id="guides-container"
        className="pb-28 md:pb-40 w-[90%] lg:w-[85%] 3xl:w-[70%] max-w-[1750px] mx-auto mb-6"
      >
        <h2 className="text-[#131313] text-lg lg:text-3xl font-semibold">
          Our Guides
        </h2>
        {mediaQuery ? (
          <GuidesMobile guidesData={guidesData?.guides} />
        ) : (
          <GuidesDesk guidesData={guidesData?.guides} />
        )}
      </div>
    </section>
  );
};

export default OurGuides;
